import ButtonRow from 'lib/src/components/button/ButtonRow';
import LinkButton from '@components/button/LinkButton';
import Table from 'lib/src/components/table/Table';
import { SuperAdminUser } from 'src/types/shared/SuperAdminUser';
import { Dispatch, SetStateAction } from 'react';
import { userRoleValues } from '../../../types/shared/User';
import ActionButton from 'lib/src/components/button/ActionButton';
import { siteNames } from 'lib/src/shared/enums/site';

const SuperAdminUsersTable: React.FC<SuperAdminUsersTableProps> = ({
    superAdminUsers,
    isFetching,
    setSuperAdminUserToEdit,
    setSuperAdminUserToEditPassword,
    setSuperAdminUserToDelete,
    setSuperAdminUserToDowngrade,
}) => {
    const columns = [
        {
            key: 1,
            heading: 'Name',
            getValue: (row: SuperAdminUser) => `${row.firstName} ${row.lastName}`,
            getSort: (a: SuperAdminUser, b: SuperAdminUser) => {
                try {
                    return a.firstName.localeCompare(b.firstName);
                } catch (e) {
                    return 0;
                }
            },
            searchable: true,
        },
        {
            key: 2,
            heading: 'Email',
            getValue: (row: SuperAdminUser) => row.email,
            searchable: true,
        },
        {
            key: 3,
            heading: 'Roles',
            getValue: (row: SuperAdminUser) => {
                return row.roles?.map(r => userRoleValues[r]).join(', ') ?? '';
            },
        },
        {
            key: 4,
            heading: 'Site Permissions',
            getValue: (row: SuperAdminUser) => siteNames[row.site],
        },
        {
            key: 5,
            heading: 'MFA Enabled?',
            getValue: (row: SuperAdminUser) => (row.hasMfa ? 'Yes' : 'No'),
        },
        {
            key: 6,
            heading: '',
            getValue: (row: SuperAdminUser) => (
                <ButtonRow alignment="top">
                    <LinkButton color="green" icon="search" href={`/superadmins/${row.id}`}>
                        View
                    </LinkButton>
                    <ActionButton
                        color="yellow"
                        icon="pencil"
                        onClick={() => setSuperAdminUserToEdit(row.id)}
                    >
                        Edit
                    </ActionButton>
                    <ActionButton
                        color="grey"
                        icon="pencil"
                        onClick={() => setSuperAdminUserToEditPassword(row.id)}
                    >
                        Edit Password
                    </ActionButton>
                    <ActionButton
                        color="blue"
                        icon="users-cog"
                        onClick={() => setSuperAdminUserToDowngrade(row.id)}
                    >
                        Downgrade to Admin
                    </ActionButton>
                    <ActionButton
                        color="red"
                        icon="times"
                        onClick={() => setSuperAdminUserToDelete(row.id)}
                    >
                        Remove
                    </ActionButton>
                </ButtonRow>
            ),
        },
    ];

    return <Table columns={columns} rows={Object.values(superAdminUsers)} isLoading={isFetching} />;
};

interface SuperAdminUsersTableProps {
    superAdminUsers: Record<number, SuperAdminUser>;
    isFetching: boolean;
    setSuperAdminUserToEdit: Dispatch<SetStateAction<number | null>>;
    setSuperAdminUserToEditPassword: Dispatch<SetStateAction<number | null>>;
    setSuperAdminUserToDelete: Dispatch<SetStateAction<number | null>>;
    setSuperAdminUserToDowngrade: Dispatch<SetStateAction<number | null>>;
}

export default SuperAdminUsersTable;
